import React from 'react';

export default function Loader() {
    return (
        <div className='spinner-box'>
            <div className='three-quarter-spinner' width='1rem' height='1rem' />
        </div>
    );
}
